/** Cores de categoria com contraste WCAG AA aproximado sobre texto branco. */
const CATEGORY_COLORS: Record<string, string> = {
  politica: "#003A63",
  economia: "#1B4D38",
  esportes: "#A84A00",
  esporte: "#A84A00",
  cultura: "#4A3B54",
  saude: "#1B4D38",
  tecnologia: "#004A7C",
  opiniao: "#4A3B54",
  mundo: "#004A7C",
  "meio-ambiente": "#1B4D38",
  "meio ambiente": "#1B4D38",
};

export function resolveCategoryColor(slug?: string | null, fallback?: string | null): string {
  if (slug) {
    const key = slug.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
    if (CATEGORY_COLORS[key]) return CATEGORY_COLORS[key];
  }
  // Fallback do banco: escurece um pouco tons claros problemáticos
  if (fallback) {
    const normalized = fallback.toLowerCase();
    if (normalized === "#f77f00" || normalized === "#ff9800") return "#A84A00";
    if (normalized === "#2d6a4f") return "#1B4D38";
    if (normalized === "#005f9f") return "#004A7C";
    return fallback;
  }
  return "#004A7C";
}
